import { memo, ReactNode, useState } from "react";

import _ from "lodash";

import {
  DEFAULT_CURRENCY_SYMBOL,
  NOT_APPLICABLE_TEXT,
} from "@zenith/data/constants";
import { formatCurrency, getSuffixedNumber } from "@zenith/utils";
import ArrowUp from "@zenith/assets/icons/ArrowUp";
import ArrowDown from "@zenith/assets/icons/ArrowDown";
import { InfoTooltipComponent } from "@zenith/components";

/* eslint-disable-next-line */
export interface ValueCardComponentProps {
  cardTitle: string;
  cardValue: number;
  isWeekly: boolean;
  infoDescription?: string | ReactNode;
  isCurrency?: boolean;
  rate?: number;
}

const ValueCardComponent = memo(function ValueCardComponent(
  props: ValueCardComponentProps
) {
  const { cardTitle, cardValue, isWeekly, infoDescription, isCurrency, rate } =
    props;

  const [open, setOpen] = useState<boolean>(false);

  const tooltipId = _.kebabCase(cardTitle);

  function handleTooltipOpen(): void {
    setOpen(!open);
  }

  function handleTooltipClose(): void {
    setOpen(false);
  }

  return (
    <div className="flex grow flex-col items-start justify-start gap-2.5 rounded-lg border border-zinc-300 bg-white p-6">
      <div className="flex items-center justify-center gap-2 text-neutral-600">
        <div className="h-2 text-sm font-normal leading-none">{cardTitle}</div>
        <div className="h-3.5 w-4">
          {infoDescription && (
            <InfoTooltipComponent
              handleTooltipClose={handleTooltipClose}
              handleTooltipOpen={handleTooltipOpen}
              open={open}
              content={infoDescription}
              tooltipId={tooltipId}
              iconColor="#626262"
              size="sm"
              nowrap
            />
          )}
        </div>
      </div>
      <p className="text-nowrap h-8 text-2xl text-neutral-900">
        {isCurrency ? (
          <>
            <span className="text-xl text-neutral-600">
              {DEFAULT_CURRENCY_SYMBOL}
            </span>{" "}
            {cardValue >= 0
              ? getSuffixedNumber(cardValue)
              : NOT_APPLICABLE_TEXT}
          </>
        ) : cardValue >= 0 ? (
          getSuffixedNumber(cardValue)
        ) : (
          NOT_APPLICABLE_TEXT
        )}
      </p>
      <div className="flex h-6 flex-row items-center justify-start gap-1.5">
        {!rate && rate !== 0 ? (
          ""
        ) : (
          <>
            <div
              className={`flex items-center justify-start gap-1 ${
                rate === 0 ? "" : rate > 0 ? "text-green-600" : "text-red-600"
              }`}
            >
              {rate > 0 && <ArrowUp />}
              {rate < 0 && <ArrowDown />}
              <span className="text-xs font-normal">{Math.abs(rate).toFixed(2)}%</span>
            </div>
            <div className="text-xs font-normal text-zinc-600">
              {isWeekly ? "Since 7 Days" : "Since 30 Days"}
            </div>
          </>
        )}
      </div>
    </div>
  );
});

export default ValueCardComponent;
